import { environment } from '../../../environments/environment';

/**
 * Sends a keepalive log line directly to the backend, bypassing the logger buffer.
 * Survives page unload. Use this for critical navigation/reload events.
 */
export function sendNavigationBeacon(message: string): void {
  const line = `[${new Date().toISOString()}] WARN  [NAV] ${message}`;
  fetch(`${environment.apiUrl}/logs/client`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ logs: line }),
    keepalive: true,
  })?.catch(() => {
    /* best-effort */
  });
}

/**
 * Single authoritative wrapper for page reloads.
 * Beacons the call stack before reloading so the reason is always logged.
 */
export function reloadPage(reason: string): void {
  const stack = new Error(reason).stack ?? reason;
  sendNavigationBeacon(`reloadPage: ${stack.replace(/\n/g, ' | ')}`);
  window.location.reload();
}

/**
 * Single authoritative wrapper for full-page href navigations.
 * Beacons before navigating so the reason survives the page unload.
 */
export function navigateTo(url: string, reason: string): void {
  sendNavigationBeacon(`navigateTo: ${url} — reason: ${reason}`);
  window.location.href = url;
}
